export default __webpack_public_path__ + "static/testimonialCompanyLogo6-1db2feac0da57c42336b3e0d820f0327.svg";